import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  permissions: []
};

const permissionsSlice = createSlice({
  name: 'permissions',
  initialState,
  reducers: {
    setPermissions(state, action) {
      state.permissions = action.payload || [];
    },
    clearPermissions(state) {
      state.permissions = [];
    }
  }
});

export const { setPermissions, clearPermissions } = permissionsSlice.actions;
export default permissionsSlice.reducer;
